module.exports = __webpack_public_path__ + "img/UC-node_rest_express_mongodb_jest.6c3af80d.jpg";